import TeamAssistMessage from 'models/team_assist_message';

/**
 * RejectTeamAssistProposedAction marks a `proposed_action` card as rejected
 * so the agent's decision survives panel/modal remount.
 *
 * Like `isExecuting`, the rejection lives on the proposed-action message in
 * the store — pure store state, no gateway call. The card reads `msg.isRejected`
 * to render its terminal state and to suppress the Execute button on remount.
 *
 * Idempotent: a second dispatch on an already-rejected message is a no-op.
 * Refuses to reject while a tool call is in flight — once Execute has been
 * pressed, the outcome belongs to the upstream call, not a competing client
 * decision.
 */
export default class RejectTeamAssistProposedAction {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, messageId }) {
    if (!customerId || !messageId) {
      return;
    }
    if (!this.context.stores.customers.has({ id: customerId })) {
      return;
    }

    const { teamAssists } = this.context.stores.customers.storesFor(customerId);
    const existing = teamAssists.find(messageId);
    if (!existing) {
      return;
    }
    if (existing.isExecuting || existing.isRejected) {
      return;
    }

    teamAssists.addOrReplace(
      TeamAssistMessage.fromJs({
        ...existing.toJs(),
        isRejected: true,
      })
    );

    this.context.analytics.track('Team Assist Proposed Action Rejected', {
      customerId,
      messageId,
      toolName: existing.proposedAction && existing.proposedAction.toolName,
    });
  }
}
